import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

import { useUser } from "../auth/useUser";
import {
  getGroupOverride,
  getRoleOverride,
  setGroupOverride,
  setRoleOverride,
} from "../hooks/useRoleOverride";
import { useGroups } from "../services/users/useGroups";

export function AdminRoleSwitcher() {
  const { t } = useTranslation();
  const { user } = useUser();
  const { data: groups } = useGroups();

  // Show switcher if user is Admin OR has an active override (only admins can set one)
  if (!(user?.roles ?? []).includes("Admin") && !getRoleOverride()) return null;

  const currentRole = getRoleOverride() ?? "";
  const currentGroup = getGroupOverride();
  const selectValue =
    currentRole === "Gruppmedlem" && currentGroup
      ? `Gruppmedlem:${currentGroup}`
      : currentRole;

  const options = [
    { value: "", label: t("admin.roleOverride.default") },
    { value: "Beredare", label: t("admin.roleOverride.Beredare") },
    ...(groups ?? []).map((g) => ({
      value: `Gruppmedlem:${g.id}`,
      label: `${g.name} (${g.caseType})`,
    })),
    { value: "Admin", label: t("admin.roleOverride.Admin") },
  ];

  const handleChange = (newValue: string) => {
    if (newValue.startsWith("Gruppmedlem:")) {
      const groupId = newValue.slice("Gruppmedlem:".length);
      setRoleOverride("Gruppmedlem");
      setGroupOverride(groupId);
    } else {
      setRoleOverride(newValue || null);
    }
    window.location.reload();
  };

  const label = t("admin.roleOverride");

  return (
    <FormControl size="small" sx={{ minWidth: 180, ml: 2 }}>
      <InputLabel id="role-override-label">{label}</InputLabel>
      <Select
        labelId="role-override-label"
        value={selectValue}
        label={label}
        onChange={(e) => handleChange(e.target.value)}
        sx={{ bgcolor: "background.paper" }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
